module.exports = __webpack_public_path__ + "static/img/no_goods.18aa752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no_goods.png
// module id = HJ6B
// module chunks = 4